import React, { useState } from "react";
import { Link } from "react-router-dom";
import { events } from "../data/mock";
import { PageHero } from "./About";
import { Calendar, X } from "lucide-react";

export const newsItems = [
  {
    id: "n1",
    title: "ಎಡಿವಿಟಿಗೆ ಪ್ಲಾಟಿನಂ ಸುಸ್ಥಿರ ಕ್ಯಾಪಸ್ ಪ್ರಶಸ್ತಿ",
    category: "Events",
    image: "/newspaper/1.png",
  },
  {
    id: "n2",
    title: "ಕೆಎಲ್ಎಸ್-ವಿಡಿಐಟಿ ಮಹಾವಿದ್ಯಾಲಯಕ್ಕೆ ಪ್ಲಾಟಿನಂ ಸುಸ್ಥಿರ ಕ್ಯಾಪಸ್ ಪ್ರಶಸ್ತಿ",
    category: "Research",
    image: "/newspaper/2.jpg",
  },
  {
    id: "n3",
    title: "ವಿಡಿಐಟಿಗೆ ಪ್ಲಾಟಿನಂ ಸುಸ್ಥಿರ ಕ್ಯಾಪಸ್ ಪ್ರಶಸ್ತಿ",
    category: "Research",
    image: "/newspaper/3.jpg",
  },
  {
    id: "n4",
    title: "ವಿಡಿಐಟಿಯಲ್ಲಿ ವಿವಿಧ ಪರಿಸರ ಜಾಗೃತಿ ಕಾರ್ಯಕ್ರಮ",
    category: "Placement",
    image: "/newspaper/4.png",
  },
  {
    id: "n5",
    title: "ವಿಡಿಐಟಿ ಯಲ್ಲಿ ವಿಶ್ವ ಪರಿಸರ ದಿನಾಚರಣೆ",
    category: "NSS",
    image: "/newspaper/5.png",
  },
  {
    id: "n6",
    title: "ವಿಡಿಐಟಿಯಲ್ಲಿ ಪರಿಸರ ದಿನಾಚರಣೆ",
    category: "Recruitment",
    image: "/newspaper/6.png",
  },
  {
    id: "n7",
    title: "ಐಇಇಇ ಪವರ್ ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್ ವಿಭಾಗ ಪೇಟೆಕ್ ಉದ್ಘಾಟನೆ",
    category: "Partnership",
    image: "/newspaper/7.png",
  },
  {
    id: "n8",
    title: "ಐಇಇಇ ಪವರ್ ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್ ವಿಭಾಗ ಪೇಟೆಕ್ ಉದ್ಘಾಟನೆ",
    category: "Events",
    image: "/newspaper/8.png",
  },
  {
    id: "n9",
    title: "ಐಇಇಇ ಪವರ್ ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್ ವಿಭಾಗ ಪೇಟೆಕ್ ಪ್ರಾರಂಭ",
    category: "Research",
    image: "/newspaper/9.jpg",
  },
  {
    id: "n10",
    title: "ನಾವಿನ್ಯ ವಿನ್ಯಾಸ ಚಿಂತನೆ ಕಾರ್ಯಾಗಾರ ಉದ್ಘಾಟನೆ",
    category: "Achievement",
    image: "/newspaper/10.png",
  },
  // {
  //   id: "n11",
  //   title: "ಪವರ್ ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್ ವಿಭಾಗ ಪೇಟೆಕ್ ಉದ್ಘಾಟನೆ",
  //   category: "Achievement",
  //   image: "/newspaper/11.png",
  // },
  {
    id: "n12",
    title: "ವಿದ್ಯಾರ್ಥಿಗಳಲ್ಲಿ ನಾವಿನ್ಯ ಚಿಂತನೆ ಬೆಳೆಸಲು ಶಿಕ್ಷಕರಿಗೆ ವಿಶೇಷ ತರಬೇತಿ",
    category: "Events",
    image: "/newspaper/12.png",
  },
];

const NewsEvents = () => {
  const [tab, setTab] = useState("news");
  const [selectedNews, setSelectedNews] = useState(null);

  return (
    <main>
      <PageHero
        title="News & Events"
        sub="What's happening at VDIT"
        image="/Campus/newshero.jpg"
      />

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
        <div className="flex gap-2 border-b border-brand/20 mb-8 font-sans-ui">
          {[
            ["news", "News"],
            ["events", "Events"],
          ].map(([k, l]) => (
            <button
              key={k}
              onClick={() => setTab(k)}
              className={`px-5 py-3 text-sm font-semibold tracking-widest transition-colors ${
                tab === k
                  ? "text-brand border-b-2 border-brand"
                  : "text-[#3a3a3a] hover:text-brand"
              }`}
            >
              {l.toUpperCase()}
            </button>
          ))}
        </div>

        {tab === "news" ? (
          <>
            <div className="columns-1 md:columns-2 lg:columns-3 gap-8">
              {newsItems.map((n) => (
                <button
                  type="button"
                  onClick={() => setSelectedNews(n)}
                  key={n.id}
                  className="bg-white border border-brand/10 card-hover block mb-8 break-inside-avoid text-left w-full"
                >
                  <div className="bg-white overflow-hidden">
                    <img
                      src={n.image}
                      alt={n.title}
                      loading="lazy"
                      className="w-full h-auto"
                    />
                  </div>
                  <div className="p-5">
                    <h3
                      className="text-brand text-[15px] font-semibold leading-tight"
                      style={{ fontFamily: "'Cormorant Garamond', serif" }}
                    >
                      {n.title}
                    </h3>
                  </div>
                </button>
              ))}
            </div>
          </>
        ) : (
          <div className="grid md:grid-cols-2 gap-6">
            {events.map((e) => (
              <Link
                to={`/event/${e.id}`}
                key={e.id}
                className="border-l-4 border-brand bg-white p-6 card-hover block"
              >
                <div className="flex items-center gap-2 text-brand text-xs tracking-wider font-sans-ui mb-2">
                  <Calendar size={14} />
                  {e.date} · {e.time}
                </div>
                <h3 className="text-[#2a2a2a] text-xl font-semibold leading-snug">{e.title}</h3>
                {e.venue && (
                  <p className="text-xs text-[#3a3a3a]/70 mt-2">Venue: {e.venue}</p>
                )}
              </Link>
            ))}
          </div>
        )}
      </section>

      {selectedNews && (
        <div
          className="fixed inset-0 z-50 bg-black/70 px-4 py-6 flex items-center justify-center"
          role="dialog"
          aria-modal="true"
          aria-labelledby="news-modal-title"
          onClick={() => setSelectedNews(null)}
        >
          <div
            className="bg-white max-w-4xl w-full max-h-[90vh] overflow-auto border border-brand/15"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="flex items-start justify-between gap-4 p-5 border-b border-brand/10">
              <h2
                id="news-modal-title"
                className="text-2xl md:text-3xl text-brand font-semibold leading-tight"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                {selectedNews.title}
              </h2>
              <button
                type="button"
                onClick={() => setSelectedNews(null)}
                className="text-brand hover:text-brand-dark p-1"
                aria-label="Close news preview"
              >
                <X size={24} />
              </button>
            </div>
            <img
              src={selectedNews.image}
              alt={selectedNews.title}
              className="w-full h-auto"
            />
          </div>
        </div>
      )}
    </main>
  );
};

export default NewsEvents;
